import React from "react";
import { BrowserRouter, routes, route, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Ventilator from "./Components/Ventilator";
import BLSamulance from "./Components/BLSamulance";
import AirAmbulance from "./Components/AirAmbulance";
import FreezerBox from "./Components/FreezerBox";
import Embalming from "./Components/Embalming";
import Navbar from "./Navbar/Navbar";
import Contact from "./Contact";
import About from "./About";
import BlogCards from "./Components/BlogCards";
import Blog1 from "./Components/Blogs/Blog1";
import Blog2 from "./Components/Blogs/Blog2";
import Blog3 from "./Components/Blogs/Blog3";
import Blog4 from "./Components/Blogs/Blog4";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        {/* <Nav /> */}
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/ventilator-ambulance" element={<Ventilator />} />
          <Route exact path="/BLS-ambulance" element={<BLSamulance />} />
          <Route exact path="/Air-ambulance" element={<AirAmbulance />} />
          <Route exact path="/freezer-box" element={<FreezerBox />} />
          <Route exact path="/Embalming" element={<Embalming />} />

          <Route exact path="/Navbar" element={<Navbar />} />

          <Route exact path="/contact" element={<Contact/>}/>
          <Route exact path="/about" element={<About/>}/>

          <Route exact path="/blog-cards" element={<BlogCards/>}/>
          <Route exact path="/rapid-blog1" element={<Blog1/>}/>
          <Route exact path="/rapid-blog2" element={<Blog2/>}/>
          <Route exact path="/rapid-blog3" element={<Blog3/>}/>
          <Route exact path="/rapid-blog4" element={<Blog4/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;

// import React, { useState } from "react";

// const users = [
//   { id: 1, name: "John Doe", age: 28, email: "john@example.com", role: "admin" },
//   { id: 2, name: "Jane Smith", age: 34, email: "jane@example.com", role: "editor" },
//   { id: 3, name: "Emily Johnson", age: 22, email: "emily@example.com", role: "viewer" },
//   { id: 4, name: "Michael Brown", age: 45, email: "michael@example.com", role: "admin" },
//   { id: 5, name: "Sarah Davis", age: 29, email: "sarah@example.com", role: "editor" },
//   { id: 6, name: "Chris Green", age: 31, email: "chris@example.com", role: "viewer" },
//   { id: 7, name: "Nancy Wilson", age: 40, email: "nancy@example.com", role: "admin" },
//   { id: 8, name: "Kevin Lee", age: 27, email: "kevin@example.com", role: "editor" },
//   { id: 9, name: "Sophia Hall", age: 35, email: "sophia@example.com", role: "viewer" },
//   { id: 10, name: "David Clark", age: 50, email: "david@example.com", role: "admin" },
// ];

// // Optional: Customize the display name of headers if needed
// const headerDisplayNames = {
//   id: "User ID",
//   name: "Full Name",
//   age: "Age",
//   email: "Email Address",
//   role: "User Role",
// };

// const UserTable = () => {
//   const [searchQuery, setSearchQuery] = useState("");

//   // Get the headers dynamically from the keys of the first user object
//   const headers = Object.keys(users[0]);

//   // Filter users based on the search query
//   const filteredUsers = users.filter((user) =>
//     headers.some((header) =>
//       user[header]
//         .toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//     )
//   );

//   // Function to highlight search text
//   const highlightText = (text) => {
//     if (!searchQuery) return text;
//     const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));
//     return parts.map((part, index) =>
//       part.toLowerCase() === searchQuery.toLowerCase() ? (
//         <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
//       ) : (
//         part
//       )
//     );
//   };

//   return (
//     <div>
//       <h1>User List</h1>
//       <input
//         type="text"
//         placeholder="Search..."
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//         style={{ marginBottom: "10px", padding: "8px", width: "100%" }}
//       />
//       <table border="1" style={{ width: "100%", textAlign: "left" }}>
//         <thead>
//           <tr>
//             {headers.map((header) => (
//               <th key={header}>
//                 {headerDisplayNames[header] ||
//                   header.charAt(0).toUpperCase() + header.slice(1)}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {filteredUsers.map((user) => (
//             <tr key={user.id}>
//               {headers.map((header) => (
//                 <td key={header}>{highlightText(user[header].toString())}</td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       {filteredUsers.length === 0 && (
//         <p style={{ color: "red" }}>No results found.</p>
//       )}
//     </div>
//   );
// };

// export default UserTable;
